import { component } from 'picoapp';
import debounce from 'lodash/debounce';

export default component(async (node: HTMLVideoElement) => {
  interface SourceData {
    [key: string]: string, // key must be a number corresponding to a breakpoint
  }

  const sourceData: SourceData = JSON.parse(node.dataset.sources);

  const sources = Object.keys(sourceData).map((key) => (
    {
      breakpoint: parseInt(key, 10),
      src: sourceData[key],
    }
  )).sort((a, b) => a.breakpoint - b.breakpoint);

  const initSrc = () => {
    const updateSrc = () => {
      const bestMatch = sources.filter((source) => source.breakpoint <= window.innerWidth).pop();
      node.src = bestMatch.src;
    };

    updateSrc();

    window.addEventListener('resize', debounce(updateSrc, 250));
  };

  const init = () => {
    initSrc();
  };

  init();
});
